module.exports = __webpack_public_path__ + "static/media/dessert-image-3.a1e337b1.png";